import { useCallback, useState } from 'react'

interface Handlers {
    open: () => void
    close: () => void
}

export const useIsOpen = (): [boolean, Handlers] => {
    const [isClearOrderConfirmationModalOpen, setIsClearOrderConfirmationModalOpen] =
        useState(false)

    const open = useCallback(() => setIsClearOrderConfirmationModalOpen(true), [])

    const close = useCallback(() => setIsClearOrderConfirmationModalOpen(false), [])

    return [isClearOrderConfirmationModalOpen, { open, close }]
}
